document.addEventListener('DOMContentLoaded', function(){
  document.querySelectorAll('a[href^="#"]').forEach(function(a){
    a.addEventListener('click', function(e){
      var id = a.getAttribute('href');
      if(id && id.length > 1){
        var el = document.querySelector(id);
        if(el){ e.preventDefault(); el.scrollIntoView({behavior:'smooth'}); }
      }
    });
  });

  var toggle = document.querySelector('[data-ayu-menu-toggle]');
  var mobileNav = document.querySelector('[data-ayu-mobile-nav]');
  if(toggle && mobileNav){
    toggle.addEventListener('click', function(){
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      mobileNav.hidden = open;
      document.body.classList.toggle('ayu-menu-open', !open);
    });
    mobileNav.querySelectorAll('a').forEach(function(link){
      link.addEventListener('click', function(){
        toggle.setAttribute('aria-expanded','false');
        mobileNav.hidden = true;
        document.body.classList.remove('ayu-menu-open');
      });
    });
  }

  var root = document.querySelector('[data-ayu-product-root]');
  if(!root) return;

  var main = root.querySelector('[data-ayu-main-image]');
  var thumbs = root.querySelectorAll('[data-ayu-product-image]');
  thumbs.forEach(function(btn){
    btn.addEventListener('click', function(){
      if(main) main.src = btn.getAttribute('data-ayu-product-image');
      thumbs.forEach(function(x){ x.classList.remove('is-active'); });
      btn.classList.add('is-active');
    });
  });

  var q = root.querySelector('[data-ayu-qty-input]');
  var m = root.querySelector('[data-ayu-qty-minus]');
  var p = root.querySelector('[data-ayu-qty-plus]');
  if(q && m && p){
    m.addEventListener('click', function(){ q.value = Math.max(1, parseInt(q.value || '1', 10) - 1); });
    p.addEventListener('click', function(){ q.value = Math.max(1, parseInt(q.value || '1', 10) + 1); });
  }

  var select = root.querySelector('[data-ayu-variant-select]');
  if(select){
    var price = root.querySelector('[data-ayu-price]');
    var compare = root.querySelector('[data-ayu-compare]');
    var stock = root.querySelector('[data-ayu-stock]');
    var add = root.querySelector('[data-ayu-add]');

    function selectThumb(mediaId){
      if(!mediaId) return;
      thumbs.forEach(function(btn){
        btn.classList.toggle('is-active', btn.getAttribute('data-media-id') === mediaId);
      });
    }

    function updateVariant(){
      var option = select.options[select.selectedIndex];
      var available = option.getAttribute('data-available') === 'true';
      var image = option.getAttribute('data-image');
      var mediaId = option.getAttribute('data-media-id');
      if(price) price.textContent = option.getAttribute('data-price') || '';
      if(compare){
        var c = option.getAttribute('data-compare') || '';
        compare.textContent = c;
        compare.hidden = !c;
      }
      if(stock){
        stock.classList.toggle('is-out', !available);
        var label = stock.querySelector('[data-ayu-stock-label]');
        if(label) label.textContent = available ? root.getAttribute('data-in-stock') : root.getAttribute('data-out-of-stock');
      }
      if(add){ var prelaunch = root.getAttribute('data-prelaunch') === 'true'; add.disabled = prelaunch || !available; add.textContent = prelaunch ? root.getAttribute('data-orders-soon') : (available ? root.getAttribute('data-add-label') : root.getAttribute('data-sold-out')); }
      if(image && main) main.src = image;
      selectThumb(mediaId);
    }

    select.addEventListener('change', updateVariant);
    updateVariant();
  }
});

